// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, NineSlicePlane, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: '26c7f44d-d548-4bc1-ba31-9b8bc55aad77',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'afa918fa-0364-4098-939c-105db9dd0a63',
      type: 'Container',
      name: 'centerWrapper',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '26c7f44d-d548-4bc1-ba31-9b8bc55aad77',
      data: {
        dynamicValues: {
          x: 'width * 0.5',
          y: 'height * 0.5'
        }
      }
    },
    {
      id: '33a4e8ec-2f2d-40e1-88ef-4520b386a7c2',
      type: 'Sprite',
      name: 'background',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 12.1875,
        y: 20
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 0,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'square_64',
      parent: 'afa918fa-0364-4098-939c-105db9dd0a63',
      data: {
        dynamicValues: {
          width: 'width * 1.1',
          height: 'height * 1.1'
        }
      }
    },
    {
      id: '7dbbeb2f-12e4-4703-9a4b-af642b118f54',
      type: 'Container',
      name: 'content',
      className: '',
      x: 0,
      y: -2000,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'afa918fa-0364-4098-939c-105db9dd0a63'
    },
    {
      id: 'e1732515-7e23-484b-95e4-6f208db1f400',
      type: 'NineSlicePlane',
      name: '',
      className: 'dynamicProps_SPL',
      x: -927,
      y: -128,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 2003,
      height: 304,
      leftWidth: 76,
      topHeight: 50,
      rightWidth: 76,
      bottomHeight: 59,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Blue_Header',
      parent: '7dbbeb2f-12e4-4703-9a4b-af642b118f54',
      data: {
        dynamicValues: {
          width: 'width * 1.4',
          x: 'width * -0.7'
        }
      }
    },
    {
      id: '50bf94c7-ec58-41c6-b639-2c8b58abd08a',
      type: 'NineSlicePlane',
      name: '',
      className: 'dynamicProps_SPL',
      x: -927,
      y: -128,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 2003,
      height: 304,
      leftWidth: 76,
      topHeight: 50,
      rightWidth: 76,
      bottomHeight: 59,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Blue_Header',
      parent: '7dbbeb2f-12e4-4703-9a4b-af642b118f54',
      data: {
        dynamicValues: {
          width: 'width * 1.4',
          x: 'width * -0.7'
        }
      }
    },
    {
      id: '95df2374-bf03-40eb-83f0-065647a7a00e',
      type: 'Container',
      name: '',
      className: '',
      x: 250,
      y: -80,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '7dbbeb2f-12e4-4703-9a4b-af642b118f54'
    },
    {
      id: 'a6ae11ca-1053-4ad5-96f4-f162740ce27b',
      type: 'Container',
      name: '',
      className: '',
      x: -250,
      y: -80,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '7dbbeb2f-12e4-4703-9a4b-af642b118f54'
    },
    {
      id: 'a690d9ff-af8d-4434-9bbf-0eed442ca6a1',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 14,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'versus_matchPopup_vs',
      parent: '7dbbeb2f-12e4-4703-9a4b-af642b118f54'
    },
    {
      id: '3da55d69-5054-41ad-b82d-769251cc9c14',
      type: 'Sprite',
      name: 'enemyAvatar',
      className: 'insertAvatar_SPL',
      x: -60,
      y: 15,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2.4,
        y: 2.4
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'avatar_placeholder',
      parent: '95df2374-bf03-40eb-83f0-065647a7a00e',
      data: {
        insertAvatar_SPL: 'versus.enemy'
      }
    },
    {
      id: '44fd92d5-b559-49ca-9518-c806cd8974d7',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.2,
        y: 1.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Profile_Picture_Frame',
      parent: '95df2374-bf03-40eb-83f0-065647a7a00e'
    },
    {
      id: '8cffd8f6-7a1a-4690-984f-2f5a90cc1b2e',
      type: 'Text',
      name: '',
      className: 'variable_SPL',
      x: 0,
      y: 177,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '<versus.enemyName>',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#1B64E1',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '95df2374-bf03-40eb-83f0-065647a7a00e'
    },
    {
      id: '4e844f06-cce6-4074-b705-ff02be75cfbd',
      type: 'Sprite',
      name: 'playerAvatar',
      className: 'userAvatar_SPL',
      x: -60,
      y: 15,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2.4,
        y: 2.4
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'avatar_placeholder',
      parent: 'a6ae11ca-1053-4ad5-96f4-f162740ce27b'
    },
    {
      id: '1e663955-2ab8-4680-abc1-62a7ed024c59',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.2,
        y: 1.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Profile_Picture_Frame',
      parent: 'a6ae11ca-1053-4ad5-96f4-f162740ce27b'
    },
    {
      id: '8b1b59b7-3fde-454d-bd2f-044d050eaf58',
      type: 'Text',
      name: '',
      className: 'variable_SPL',
      x: 0,
      y: 177,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '<player.name>',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#1B64E1',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'a6ae11ca-1053-4ad5-96f4-f162740ce27b'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '4.0.1',
  animations: [
    {
      id: '61f07472-c95b-4d83-9c68-87d150707ade',
      name: 'Appear',
      playingSpeed: 1,
      totalDuration: 2500,
      blocks: [
        {
          id: '8e2486ff-4c14-47f0-97d2-6f2cc663b8fd',
          type: 'Tween',
          name: 'New_tween',
          duration: 300,
          track: 2,
          target: {
            alpha: 0.6
          },
          startAt: 0,
          sourceName: 'background',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '8b01aa07-728d-4697-a9bf-3b6d2b95d32c',
          type: 'Tween',
          name: 'contentDown',
          duration: 400,
          track: 4,
          target: {
            y: 0
          },
          startAt: 223,
          sourceName: 'content',
          easing: 'BackOut',
          disabled: false
        },
        {
          id: 'b77d62b0-f18d-4bf4-aa21-a3cd84956c97',
          type: 'Tween',
          name: 'contentDown_copy',
          duration: 400,
          track: 4,
          target: {
            y: -2000
          },
          startAt: 2037,
          sourceName: 'content',
          easing: 'BackIn',
          disabled: false
        },
        {
          id: '055d01ba-5cb1-4e2e-8960-69938988e493',
          type: 'Tween',
          name: 'New_tween_copy',
          duration: 300,
          track: 2,
          target: {
            alpha: 0
          },
          startAt: 2198,
          sourceName: 'background',
          easing: 'SinusoidalOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class VersusPreviewOverlayLayout {
  static raw = raw;
  root!: Container;
  centerWrapper!: Container & { data: typeof raw['list'][1]['data'] };
  background!: Sprite & { data: typeof raw['list'][2]['data'] };
  content!: Container;
  enemyAvatar!: Sprite & { data: typeof raw['list'][9]['data'] };
  playerAvatar!: Sprite;
  dynamicProps_SPL!: (Container & { data: typeof raw['list'][1]['data'] } | Sprite & { data: typeof raw['list'][2]['data'] } | NineSlicePlane & { data: typeof raw['list'][4]['data'] } | NineSlicePlane & { data: typeof raw['list'][5]['data'] })[];
  insertAvatar_SPL!: (Sprite & { data: typeof raw['list'][9]['data'] })[];
  variable_SPL!: (Text)[];
  userAvatar_SPL!: (Sprite)[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class Appear {
  Layout: {
    background: object;
    content: object;
  };

  BlockTypeByName: {
    New_tween: object;
    contentDown: object;
    contentDown_copy: object;
    New_tween_copy: object;
  };

  flowData = raw.animations[0];
}
